import * as React from 'react';
import { debounce } from 'throttle-debounce';
import { Form } from '@grandvisionhq/forms';

const CheckoutForm = ({ children , formName , onChange , initialFormState ,  })=>{
    const debouncedHandleChange = React.useMemo(()=>{
        return debounce(200, onChange);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ React.createElement(Form, {
        name: formName,
        "data-t": formName,
        initialFormState: initialFormState,
        onChange: debouncedHandleChange
    }, children);
};

export { CheckoutForm };
//# sourceMappingURL=CheckoutForm.js.map
